<button
  #knopf
  type="button"
  class="ki-button"
  data-testid="ki-button"
  [class.ki-button--laeuft]="zustand().state === 'laeuft'"
  [class.ki-button--gesperrt]="zustand().state === 'gesperrt'"
  [attr.aria-disabled]="zustand().state === 'aktiv' ? null : 'true'"
  [attr.aria-expanded]="sperrtextKey() ? hinweisOffen() : null"
  [attr.aria-controls]="hinweisOffen() ? hinweisId : null"
  [matTooltip]="sperrtextKey() ?? '' | translate"
  (click)="aktivieren()"
>
  <app-ki-mark class="ki-button__mark" [size]="18" />
  {{ zustand().state === 'laeuft' ? ('ki.button.laeuft' | translate) : label() }}
</button>
@if (hinweisOffen()) {
  <div class="ki-button__hinweis" role="status" data-testid="ki-button-hinweis" [id]="hinweisId">
    {{ sperrtextKey() ?? '' | translate }}
    @if (verbindungEinrichtenLink(); as ziel) {
      <a class="ki-button__link" [routerLink]="ziel">{{ 'ki.button.verbindungEinrichten' | translate }}</a>
    }
  </div>
}
